import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function getApiUrl(): string {
  const base = import.meta.env.VITE_API_BASE_URL;
  const apiPath = import.meta.env.VITE_API_PATH;
  return `${base}${apiPath}`;
}

export const HELP_URL = import.meta.env.VITE_HELP_URL

export function formatFilenameTimestamp(date: Date = new Date()): string {
  const pad = (n: number, len = 2) => String(n).padStart(len, "0")
  return (
    `${date.getFullYear()}${pad(date.getMonth() + 1)}${pad(date.getDate())}` +
    `_${pad(date.getHours())}${pad(date.getMinutes())}${pad(date.getSeconds())}` +
    pad(date.getMilliseconds(), 3)
  )
}
